export default __webpack_public_path__ + "static/media/auth.c722ef89.webp";